const DEFAULT_FRECUENCIA_VALUE = 5
const DEFAULT_STATUS_VALUE = true

class ReactivoDto {
  constructor(id = null, idReactivo, idFrecuencia, estatus = DEFAULT_STATUS_VALUE) {
    this.id = id
    this.fk_idReactivoValor = idReactivo
    this.fk_idCatFrecuencia = idFrecuencia
    this.estatus = estatus
  }

  static create(reactivo) {
    const reactivoDto = new ReactivoDto(null, reactivo.id, DEFAULT_FRECUENCIA_VALUE)

    return {
      fk_idReactivoValor: reactivoDto.fk_idReactivoValor,
      fk_idCatFrecuencia: reactivoDto.fk_idCatFrecuencia,
    }
  }
}

export default ReactivoDto
